import { ThemeGradientColor } from '../../types';

export const GRADIENT: Record<ThemeGradientColor, string> = {
  gradientPeriwinkle: '#5A6DD3',
};
